import React, { useEffect, useState } from 'react';
import AuthService from '../../services/auth-service';
import ResetPasswordForm from './ResetPasswordForm';
import ResetPassword from './ResetPassword';
import { Link } from 'react-router-dom';

const PasswordReset = () => {
  const [msisdn, setMsisdn] = useState('');
  const [step, setStep] = useState(1);
  const [agent, setAgent] = useState({});

  const onResetSuccess = (agentPayload) => {
    setAgent(agentPayload);
    setStep((s) => s + 1); // functional update prevents stale closure
  };

  useEffect(() => {
    // Pre-fetch access token required by backend for reset endpoints
    AuthService.getAccessToken();
  }, []);

  return (
    <div>
      <section className="min-h-screen flex items-stretch text-black ">
        {/* Left panel - content */}
        <div className="lg:w-2/5 w-full gap-11 flex flex-col items-start justify-center bg-white text-center md:px-16 px-4 z-0">
          <h1 className="text-3xl font-bold">Instaant</h1>
          <div className="w-full py-6 z-20">
            <div className="w-full z-10">
              <p className="text-2xl my-4">Reset Your Password</p>
              <p className="text-gray-600 mb-6">
                You will receive an SMS with a temporary password to create a new password.
              </p>
            </div>

            {step === 1 ? (
              <ResetPasswordForm
                userType="agent"
                step={step}
                setStep={setStep}
                msisdn={msisdn}
                setMsisdn={setMsisdn}
                onSuccess={onResetSuccess}
              />
            ) : (
              <ResetPassword userType="agent" staffOrAgent={agent} />
            )}
          </div>
        </div>

        {/* Right panel - themed background */}
        <div className="auth-bg-cover-theme w-full lg:flex flex-col hidden">
          <div className=" bg-auth-img bg-no-repeat relative">
            <p className="absolute bottom-4 right-16 text-white text-xs">Privacy Policy & Terms of Use</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PasswordReset;